import { useTranslation } from 'react-i18next';

export function useTitleBlockController() {
  const { t } = useTranslation();

  const titleBlockText = t('charity.steps.titleBlock');

  return { titleBlockText };
}
